import { render, staticRenderFns } from "./RightSideNotification.vue?vue&type=template&id=6e298eb3&scoped=true"
import script from "./RightSideNotification.vue?vue&type=script&lang=js"
export * from "./RightSideNotification.vue?vue&type=script&lang=js"
import style0 from "./RightSideNotification.vue?vue&type=style&index=0&id=6e298eb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e298eb3",
  null
  
)

export default component.exports